import { protectedGet } from "./restUtil";
import * as _ from "underscore";

export function fetchLevels(args, onSuccess, onError) {
  return protectedGet(
    "/levels",
    undefined,
    function (resp) {
      if (!resp || !resp.list) {
        return onError && onError("invalid response structure");
      }
      return onSuccess(_.sortBy(resp.list, "value"));
    },
    onError
  );
}
